import React from 'react';
import { locales } from '../../translations/locales';

const ModalForgotPwd = (props) => {
    const { setModal, session, locale } = props;

    return (
        <div className='modal-dialog modal-dialog-scrollable modal-dialog-centered'>
            <div className='modal-content'>
                <div className='modal-header'>
                    <h5 className='modal-title' id='modalTitle'>{locales[locale].session.logIn} {locales[locale].to} {locales[locale].title}</h5>
                    <button type='button' className='close' data-dismiss='modal' aria-label='Close' id='modalClose'>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </div>
                <div className='modal-body text-center' id='modal-body'>
                    <div className='text-dark'>
                        {locales[locale].session.forgotPwd}
                    </div>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        session.forgotPwd();
                    }}>
                        <p className='text-dark'>{locales[locale].session.forgotIndications}</p>
                        <input type='text' id='username' className='fadeIn first' placeholder={locales[locale].session.userName} />
                        <div className='m-2 text-center'>
                            <button type='button' className='pop-ip-btn-vld' onClick={() => session.forgotPwd()}>
                                <span className='pop-ip-btn-vld-txt'>
                                    <span>{locales[locale].send}</span>
                                </span>
                                <span className='pop-ip-btn-vld-2'></span>
                            </button>
                        </div>
                    </form>
                    <div className='modal-footer' id='modal-footer'>
                        <div id='formFooter'>
                            <div className='pop-up-bot'>
                                <div className='pop-up-bot-1'>
                                    <div className='pop-up-bot-2'>{locales[locale].session.noAccount}&nbsp;?</div>
                                    <button className='pop-up-bot-3 ml-1' onClick={() => setModal('ModalSignIn')}>
                                        <span className='pop-up-bot-4'>
                                            <span>{locales[locale].session.signUp}</span>
                                        </span>
                                        <span className='pop-up-bot-5'></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalForgotPwd;
